<template>
  <div>
    <div class="setLanguageValue" :class="{isTextarea: textarea}">
      <textarea
        v-if="textarea" v-model="langValue[defaultLang]"
        class="input textarea"
        :disabled="disabled || disabledLangCodes?.includes(defaultLang)"
        @focusout="fillLangs">
      </textarea>
      <input
        v-else
        v-model="langValue[defaultLang]"
        class="input"
        :disabled="disabled || disabledLangCodes?.includes(defaultLang)"
        @focusout="fillLangs" />
      <button
        type="button"
        class="btnLanguage"
        :title="locale.language_specific_set"
        @click.stop="setLanguage"></button>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :langValue="langValue"
      :title="locale.language_specific_set"
      :textarea="textarea"
      :disabled="disabled"
      :disabledLangCodes="disabledLangCodes"
      @close="closeLanguage" />
    <!-- //언어별 세팅 -->
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import LANG from '@/common/lang'
import LangValue from '@/components/Util/LangValue'

export default {
  name: 'SetLanguageValue',
  props: [
    'locale',
    'langValue',
    'textarea',
    'disabled',
    'disabledLangCodes'
  ],
  components: {
    LangValue
  },
  computed: {
    lang () {
      return this.$store.getters['setting/getData'].lang
    },
    defaultLang () {
      return this.lang.default
    },
  },
  watch: {
    langValue: {
      deep: true,
      handler (data) {
        this.ensureLangKeys()
      }
    }
  },
  data () {
    return {
      langValueLayer: false,
    }
  },
  methods: {
    fillLangs () {
      const LANG_USABLE = this.lang.info.filter(x => x.u).map(x => x.c)
      if (this.langValue) {
        Object.keys(this.langValue).forEach(x => {
          if (regExp.replaceAllEmpty(this.langValue[x]) === '') {
            this.langValue[x] = this.langValue[this.defaultLang]
          }
        })
      }
    },
    ensureLangKeys() {
      const LANG_USABLE = this.lang.info.filter(x => x.u).map(x => x.c)
      const LANG_DEFAULTS = this.$store.getters['setting/getLangValues']()
      let v = this.langValue; // props

      if (!v || typeof v !== 'object') return

      const nextValue = {};

      // 유효한 키만 새 객체에 복사
      for (const k of Object.keys(v)) {
        if (LANG_USABLE.includes(k)) {
          nextValue[k] = v[k]
        }
      }

      // 없는 언어 키 주입
      for (const k of Object.keys(LANG_DEFAULTS)) {
        if (!(k in nextValue)) {
          nextValue[k] = LANG_DEFAULTS[k]
        }
      }

      // 기존 객체의 내용을 일단 다 비움 (삭제 대신 빈 값을 할당)
      Object.keys(v).forEach(k => {
        if (!(k in nextValue)) {
          // 삭제가 안 먹힌다면 일단 값이라도 무효화
          this.$set(v, k, undefined)
          // 그 후 강제 삭제 시도
          this.$delete(v, k)
        }
      })

      // 새로운 값들로 덮어쓰기
      Object.assign(v, nextValue);

      // Vue에게 이 객체가 변했음을 강제로 알림
      this.$set(this, 'langValue', v)
    },
    setLanguage () {
      // this.fillLangs()
      this.langValueLayer = true
    },
    closeLanguage () {
      this.langValueLayer = false
    },
  }
}
</script>